
(function() {
  var result = { translations: { "x-pseudo": { "i18n": { "duration": { "seconds": "[{{ \u015F\u1E17\u0188\u01FF\u019E\u1E13\u015F }} \u015F\u1E17\u0188 \u01C8\u03F1 \u9DB1\u9DB1\u01C5\u017F\u017F\u03C2\u03D0 \u0131]", "minutes": "[{{ \u1E3F\u012B\u019E\u016D\u0167\u1E17\u015F }} \u1E3F\u012B\u019E \u03F0\u03F1 \u03D5\u884B\u9DB1\u03D1\u03D6\u884B\u03F1 \u03D1]", "hours": "[{{ \u0127\u01FF\u016D\u0159\u015F }} \u0127\u0159 \u884B\u03F0 \u01CB\u03D0\u03F1\u01C8\u03D5 \u9750\u0131]", "hoursAndMinutes": "[{{ \u0127\u01FF\u016D\u0159\u015F }} \u0127\u0159 {{ \u1E3F\u012B\u019E\u016D\u0167\u1E17\u015F }} \u1E3F\u012B\u019E \u0131\u03F1 \u0131\u01C5\u03F0\u03D1\u1E9B \u9750\u0131]", "days": "[{{ \u1E13\u0227\u1E8F\u015F }} \u1E13\u0227\u1E8F\u015F \u0131\u03D1 \u884B\u017F\u9750\u01CB \u0390\u01CB]", "shortForm": { "seconds": "[{{ \u015F\u1E17\u0188\u01FF\u019E\u1E13\u015F }}\u015F \u017F\u0131 \u0390\u01F2\u01C8\u03C2\u9DB1\u01C8\u01C5 \u1E9B]", "minutes": "[{{ \u1E3F\u012B\u019E\u016D\u0167\u1E17\u015F }}\u1E3F \u01C5\u03F1 \u0131\u03D0\u03C2\u03D1\u0131\u01C5\u1E9B \u0131]", "hours": "[{{ \u0127\u01FF\u016D\u0159\u015F }}\u0127 \u03F0\u03C2 \u01C5\u01C5\u9750\u03F5\u01CB \u01CB]", "days": "[{{ \u1E13\u0227\u1E8F\u015F }}\u1E13 \u03D6\u9750 \u03D1\u03F1\u9750\u884B \u03D1\u03F1\u03D5]", "hoursAndMinutes": "[{{ \u0127\u01FF\u016D\u0159\u015F }}\u0127 {{ \u1E3F\u012B\u019E\u016D\u0167\u1E17\u015F }}\u1E3F \u884B\u9750 \u03D5\u03F5\u017F\u03F0\u9750 \u03F5]" } }, "dateTime": { "quarterAndYear": "[\u024A{{quarterNumber}} {{yearNumber}} \u9DB1\u03D5\u03D6\u017F\u01CB\u1E9B\u0131\u01CB\u03D5\u01C8]" }, "numberRepresentation": { "fraction": "[{{ \u019E\u016D\u1E3F\u1E17\u0159\u0227\u0167\u01FF\u0159 }}/{{ \u1E13\u1E17\u019E\u01FF\u1E3F\u012B\u019E\u0227\u0167\u01FF\u0159 }} \u03C2\u01C5 \u884B\u9DB1\u03D6\u9DB1\u03C2\u01F2\u01C8]", "numberWithCurrencyCode": "[{{currencyCode}} {{amountNumberValue}} \u03D1\u03F1\u03F0\u03D0\u03D1\u884B\u01CB\u03D0\u9DB1\u0390\u9750]", "phoneNumberWithExtension": "[{{phoneNumber}}, \u1E17\u1E8B\u0167. {{extension}} \u03D1\u0131\u03D0\u03F5\u01F2\u03D1\u0390\u03F5\u9DB1\u03D5\u0390]" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "x-pseudo": "static-7.1179"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1179",
    "ar-eg": "static-7.1179",
    "bg": "static-7.1179",
    "bn": "static-7.1179",
    "ca-es": "static-7.1179",
    "cs": "static-7.1179",
    "da": "static-7.1179",
    "de": "static-7.1179",
    "el": "static-7.1179",
    "en-gb": "static-7.1179",
    "en": "static-7.1179",
    "es-mx": "static-7.1179",
    "es": "static-7.1179",
    "et": "static-7.1179",
    "fi": "static-7.1179",
    "fr-ca": "static-7.1179",
    "fr": "static-7.1179",
    "he-il": "static-7.1179",
    "hi": "static-7.1179",
    "hr": "static-7.1179",
    "hu": "static-7.1179",
    "id": "static-7.1179",
    "it": "static-7.1179",
    "ja": "static-7.1179",
    "ko": "static-7.1179",
    "lt": "static-7.1179",
    "ms": "static-7.1179",
    "nl": "static-7.1179",
    "no": "static-7.1179",
    "pl": "static-7.1179",
    "pt-br": "static-7.1179",
    "pt-pt": "static-7.1179",
    "ro": "static-7.1179",
    "ru": "static-7.1179",
    "sk": "static-7.1179",
    "sl": "static-7.1179",
    "sv": "static-7.1179",
    "th": "static-7.1179",
    "tl": "static-7.1179",
    "tr": "static-7.1179",
    "uk": "static-7.1179",
    "vi": "static-7.1179",
    "x-pseudo": "static-7.1179",
    "zh-cn": "static-7.1179",
    "zh-hk": "static-7.1179",
    "zh-tw": "static-7.1179"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:x-pseudo', {version: 'static-7.1179'}); }
})();


